import React, { forwardRef, useState } from "react";
import cx from "classnames";
import styled from 'styled-components';
import CtaButton from "./components/CtaButton";
import IBuildrProps from '../../utilities/IBuildrProps';

interface IRatesList extends IBuildrProps {
    heading: string;
    ctaText: string;
    ctaHyperLink: string
    children: any;
}

export default styled(forwardRef((props: IRatesList, ref: any) => {
    const { cmsId, editorClassObj, className, children, heading, ctaText, ctaHyperLink } = props;
    const childrenLength = React.Children.count(children);

    const [activeTab, setActiveTab] = useState(0);

    return (
        <div ref={ref} data-id={cmsId} className={cx('wrapper p-2', className, editorClassObj)}>
            <div className="heading-wrap justify-content-between d-flex mb-3">
                <h2 className="heading">{heading}</h2>
                {children && childrenLength === 1 ?
                    <CtaButton 
                        ctaText={ctaText}
                        ctaHyperLink={ctaHyperLink}
                        customClass="d-none d-lg-inline-flex"
                    />
                : null
                }
            </div>      
            <div className="categories-wrap d-flex flex-wrap">
                {children && childrenLength > 1 ?
                    <div className={`form-group d-block d-lg-none`}>
                        <div className="input-group">
                            <select className='form-control rounded' value={activeTab} onChange={(e) => setActiveTab(Number(e.target.value))}>
                                {children.map((category, index) => {
                                    return (
                                        <option key={category.props.categoryTitle} value={index}>{category.props.categoryTitle}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                : null }
                {React.Children.map(children,(category, index) => {
                    return React.cloneElement(category, {
                        setActiveTab,
                        tabId: index,
                        selected: activeTab === index,
                        categoriesLength: childrenLength,
                        ctaText,
                        ctaHyperLink
                    });
                })}
            </div>
            <CtaButton 
                ctaText={ctaText}
                ctaHyperLink={ctaHyperLink}
                customClass={"d-inline-flex d-lg-none"}
            />
        </div>
    );
}))`

.categories-wrap {
    .form-group {
        flex-grow: 1;
        margin: 0;
        padding-right: 0;
        .form-control {
            border: 1px solid #bdbdbd; 
        }
        @media(min-width:992px) {
            min-width: 480px;
        }
    }
    @media(max-width:992px) {
        margin-bottom: 1rem;
    }
}
.heading-wrap {
    h2 {
        font-family: "National2", sans serif;
        margin: 0;
    }
}`;
